module.exports = __webpack_public_path__ + "static/media/drop_uncheckbox.06f19a5b.svg";